// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606030953/js/" + chunkId + "." + {"44":"5822f1e6","225":"203aa295","481":"ec1ee1fc","486":"1ae846fb","770":"0d585d80"}[chunkId] + ".0.24103806738581168.chunk.js";
};